document.addEventListener('DOMContentLoaded', function() {
    const popup = document.getElementById('imagePopup');
    const popupImg = document.getElementById('popupImage');
    const closeBtn = document.querySelector('.close-btn');
    const openPopupBtns = document.querySelectorAll('.open-popup');

    const closePopup = () => {
        popup.style.display = 'none';
        document.body.style.overflow = 'auto';
    };

    openPopupBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.preventDefault();

            const desktopSrc = this.getAttribute('data-image');
            const mobileSrc = this.getAttribute('data-mobile-image');

            if (window.innerWidth < 768 && mobileSrc) {
                popupImg.src = mobileSrc;
            } else {
                popupImg.src = desktopSrc;
            }

            popup.style.display = 'flex';
            document.body.style.overflow = 'hidden';
        });
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', closePopup);
    }

    if (popup) {
        popup.addEventListener('click', function(e) {
            if (e.target === popup) closePopup();
        });
    }

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.style.display === 'flex') {
            closePopup();
        }
    });
});

(function () {
    const BP_MOBILE = 599;
    const BP_TABLET = 989;

    const containerSelector = '.product__media-list__container--great-five';
    const activeClass = 'is-mobile-carousel';

    let dotsWrapper = null;
    let isCarouselActive = false;

    function createDots(container) {
        if (dotsWrapper) return;

        const items = container.querySelectorAll('.product__media-item');
        if (items.length <= 1) return;

        dotsWrapper = document.createElement('div');
        dotsWrapper.className = 'mobile-carousel-dots';

        items.forEach((_, index) => {
            const dot = document.createElement('span');
            dot.className = 'mobile-carousel-dot';
            if (index === 0) dot.classList.add('is-active');

            dot.addEventListener('click', () => {
                container.scrollTo({
                    left: container.clientWidth * index,
                    behavior: 'smooth'
                });
            });

            dotsWrapper.appendChild(dot);
        });

        container.after(dotsWrapper);
    }

    function updateDots(container) {
        if (!dotsWrapper) return;

        const index = Math.round(container.scrollLeft / container.clientWidth);
        const dots = dotsWrapper.querySelectorAll('.mobile-carousel-dot');

        dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === index);
        });
    }

    function destroyDots() {
        if (!dotsWrapper) return;
        dotsWrapper.remove();
        dotsWrapper = null;
    }

    function initCarousel(container) {
        if (isCarouselActive) return;

        container.classList.add(activeClass);
        container.scrollLeft = 0;

        container.addEventListener('scroll', () => {
            window.requestAnimationFrame(() => updateDots(container));
        });

        isCarouselActive = true;
    }

    function destroyCarousel(container) {
        if (!isCarouselActive) return;

        container.classList.remove(activeClass);
        destroyDots();

        isCarouselActive = false;
    }

    function checkViewport() {
        const container = document.querySelector(containerSelector);
        if (!container) return;

        const width = window.innerWidth;

        if (width <= BP_TABLET) {
            initCarousel(container);
            createDots(container);
        } else {
            destroyCarousel(container);
        }
    }

    document.addEventListener('DOMContentLoaded', checkViewport);
    window.addEventListener('resize', checkViewport);
})();
(function() {
    const handleMenuOpen = () => {
        const targetMenu = document.querySelector('#menu-drawer .menu-drawer__menu li:nth-child(2) > details');

        if (!targetMenu) return;

        if (window.innerWidth <= 1099) {
            targetMenu.setAttribute('open', 'true');
        } else {
            targetMenu.removeAttribute('open');
        }
    };

    handleMenuOpen();

    window.addEventListener('resize', handleMenuOpen);
})();